module.exports = __webpack_public_path__ + "img/work1.cca1fc12.gif";